module.exports = __webpack_public_path__ + "static/Monitoring-866b869d3c651e9fb06d26b7209a458d.png";